/* eslint-disable eqeqeq */
import * as _ from "lodash";
import { getDDMMYYYFormat } from "../../../../../helper/dateTimeHelper";
import * as FileSaver from "file-saver";
import { logoBase64 } from "../../../info-technology-process/repair-tools/base64";
import ExcelJS from "exceljs";
import { breakLine, makeBold } from "../../summary-employee-request/utils";
import { eApproveTitleCode } from "../../../../../constants/bizTitle";

export const isCreatedByCurrentUser = (detail: any, currentUser: string) => {
  return (
    detail?.createdBy?.user?.email?.toLowerCase()?.split("@")?.[0] ===
    currentUser.toLowerCase().split("@")?.[0]
  );
};

export const isEnableEdit = (
  nextStep: number,
  detail: any,
  currentUser: string
) => {
  return isCreatedByCurrentUser(detail, currentUser) && nextStep === 1;
};

export const filterEmployeesByDepartment = (
  departments: any[],
  employees: any[],
  department: string
) => {
  const selectedDepartment = departments.filter(
    (value) => value.value == department
  )[0];

  return employees.filter(
    (value) =>
      eApproveTitleCode.indexOf(value.eBizTitleCode) > -1 &&
      value.eDepartmentCode == selectedDepartment?.id
  );
};

export function createWorkSheet(
  record: any,
  workbook: any,
  worksheetName: string
) {
  const worksheet = workbook.addWorksheet(worksheetName);

  const imageId = workbook.addImage({
    base64: logoBase64,
    extension: "png",
  });

  let eContent;

  try {
    eContent = JSON.parse(record.fields.eContent);
  } catch (error) {
    eContent = record?.data || [];
  }

  if (eContent.length == 0) {
    return;
  }

  

  const eIssueNumber = eContent?.[0]?.eIssueNumber || "";
  const eIssueTimes = eContent?.[0]?.eIssueTimes || "";
  const eIssueEffectiveDate = eContent?.[0]?.eIssueEffectiveDate || "";

  worksheet.addImage(imageId, "A1:D3");
  worksheet.addRow(["", "", "", "", "Biểu mẫu", `Mã số: ${eIssueNumber}`]);
  worksheet.addRow([
    "",
    "",
    "",
    "",
    "TỔNG HỢP NHÂN SỰ ĐĂNG KÝ KHÓA HỌC",
    `Lần ban hành: ${eIssueTimes}`,
  ]);

  worksheet.addRow([
    "",
    "",
    "",
    "",
    "",
    `Ngày hiệu lực:  ${getDDMMYYYFormat(eIssueEffectiveDate)}`,
  ]);

  breakLine(worksheet, 1);

  worksheet.addRow([
    "Nghiệp vụ",
    "Loại hình đào tạo",
    "Họ và tên",
    "Mã NV",
    "Đơn vị",
    "Ngày bắt đầu",
    "Ngày kết thúc",
  ]);

  for (let index = 0; index < eContent.length; index++) {
    const element = eContent[index];
    if (index == 0) continue;
    if (!element.eMajor) element.eMajor = eContent[index - 1].eMajor || "";
    if (!element.eTrainingType)
      element.eTrainingType = eContent[index - 1].eTrainingType || "";
    if (!element.eCourseDate && eContent[index - 1].eCourseDate)
      element.eCourseDate = eContent[index - 1].eCourseDate;
    if (!element.eCourseDateEnd && eContent[index - 1].eCourseDateEnd)
      element.eCourseDateEnd = eContent[index - 1].eCourseDateEnd;
  }

  if (worksheetName === "CN Tân Sơn Nhất") {
    eContent = eContent.filter(
      (value: any) => value.unit === "Chi nhánh Tân Sơn Nhất"
    );
  }
  if(worksheetName === "Khối cơ quan"){
    eContent = eContent.filter(
      (value: any) => value.unit != "Chi nhánh Tân Sơn Nhất"
    );
  }

  for (const item of eContent) {
    worksheet.addRow([
      item.eMajor,
      item.eTrainingType,
      item.fullName,
      item.registerPersonel,
      item.unit,
      getDDMMYYYFormat(item.eCourseDate),
      getDDMMYYYFormat(item.eCourseDateEnd),
    ]);
  }

  breakLine(worksheet, 2);

  worksheet.addRow([
    "Người lập",
    "",
    "",

    "TCNL hoặc KHHC",
    "",
    "",

    "Tổng Giám đốc hoặc Giám đốc",
    "",
    "",
  ]);

  let currentRowIdx = worksheet.rowCount;

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  breakLine(worksheet, 3);

  worksheet.addRow([
    "Họ và tên: ",
    "",
    "",

    "Họ và tên: ",
    "",
    "",

    "Họ và tên: ",
    "",
    "",
  ]);

  currentRowIdx = worksheet.rowCount;

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);
  makeBold(worksheet, 1, 6);
  makeBold(worksheet, 2, 6);
  makeBold(worksheet, 3, 6);

  makeBold(worksheet, 1, 5);
  makeBold(worksheet, 2, 5);

  for (const i of _.range(7)) {
    makeBold(worksheet, 5, i + 1);
  }

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  worksheet.addRow(["Ngày: ", "", "", "Ngày: ", "", "", "Ngày: ", "", ""]);

  currentRowIdx = worksheet.rowCount;

  worksheet.mergeCells(currentRowIdx, 1, currentRowIdx, 3);
  worksheet.mergeCells(currentRowIdx, 4, currentRowIdx, 6);
  worksheet.mergeCells(currentRowIdx, 7, currentRowIdx, 9);

  makeBold(worksheet, currentRowIdx, 1);
  makeBold(worksheet, currentRowIdx, 4);
  makeBold(worksheet, currentRowIdx, 7);
}

export function exportExcel(record: any, eLocationParam?:string) {
  let eContent;

  try {
    eContent = JSON.parse(record.fields.eContent);
  } catch (error) {
    eContent = record?.data || [];
  }

  if (eContent.length == 0) {
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const eLocation = eLocationParam ? eLocationParam : record.fields.eLocation;
  if (eLocation === "TSN") {
    createWorkSheet(record, workbook, "Khối cơ quan");
    createWorkSheet(record, workbook, "CN Tân Sơn Nhất");
  } else if (eLocation === "DAD") {
    createWorkSheet(record, workbook, "CN Đà Nẵng");
  } else {
    createWorkSheet(record, workbook, "CN Nội Bài");
  }

  workbook.xlsx.writeBuffer().then((data) => {
    const blob = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(
      blob,
      `Bảng tổng hợp nhân sự tham gia khóa học - ${getDDMMYYYFormat(
        new Date()
      )}`
    );
  });
}
